import { render, staticRenderFns } from "./ExpressLabelsTable.vue?vue&type=template&id=b30ecae2&scoped=true"
import script from "./ExpressLabelsTable.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30ecae2",
  null
  
)

export default component.exports